import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };
    return (
        <header className="site-header">
            <div className="header-container">
                <Link to="/" className="logo">
                    ANDREA LIŠKOVÁ
                </Link>
                <button className="mobile-menu-toggle" onClick={toggleMenu}>
                    {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>

                <nav className={`main-nav ${isMenuOpen ? 'mobile-open' : ''}`}>
                    <ul className="nav-list">
                        <li><NavLink to="/" onClick={closeMenu}>Home</NavLink></li>
                        <li className="nav-dropdown">
                            <NavLink to="/sluzby" onClick={(e) => {
                                // On mobile, we might want to toggle the dropdown instead of navigating
                                if (window.innerWidth <= 768) {
                                    e.preventDefault();
                                }
                            }}>Služby</NavLink>
                            <div className="dropdown-menu">
                                <Link to="/strategie" onClick={closeMenu}>Strategie</Link>
                                <Link to="/web" onClick={closeMenu}>Web</Link>
                                <Link to="/vykon" onClick={closeMenu}>Výkon</Link>
                            </div>
                        </li>
                        <li><NavLink to="/kontakt" onClick={closeMenu}>Kontakt</NavLink></li>
                    </ul>
                    <a href="https://cal.eu/andrea-liskova/30min" target="_blank" rel="noopener noreferrer" className="btn btn-primary" onClick={closeMenu}>
                        Rezervovat konzultaci
                    </a>
                </nav>
            </div>
        </header>
    );
}

export default Header;
